'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  DropdownTriggerArrowCloseIconButton,
  DropdownTriggerArrowOpenIconButton,
  DropdownTriggerBox,
  DropdownTriggerInput,
  IcDelete,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  SheetTrigger,
  Typography,
} from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';
import { usePreventBodyScroll } from '../../../../common/hooks';
import { PLATFORMS, type Platform } from '../constants/platforms';

interface PlatformSelectDropdownProps {
  value?: Platform;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSelect: (platform: Platform) => void;
  placeholder?: string;
  className?: string;
}

export const PlatformSelectDropdown = ({
  value,
  isOpen,
  onOpenChange,
  onSelect,
  placeholder = '플랫폼을 선택해주세요',
  className,
}: PlatformSelectDropdownProps) => {
  usePreventBodyScroll({ open: isOpen });

  const onPlatformSelect = (platform: Platform) => {
    onSelect(platform);
    onOpenChange(false);
  };

  return (
    <div className={twMerge('', className)}>
      <Sheet direction="bottom" open={isOpen} onOpenChange={onOpenChange}>
        <SheetTrigger asChild>
          <DropdownTriggerBox>
            <DropdownTriggerInput placeholder={placeholder} value={value?.name || ''} />
            <DropdownTriggerArrowOpenIconButton />
            <DropdownTriggerArrowCloseIconButton />
          </DropdownTriggerBox>
        </SheetTrigger>
        <SheetPortal>
          <SheetContent
            onPointerDownOutside={() => {
              onOpenChange(false);
            }}
          >
            <SheetMotion direction="bottom">
              <BottomSheetTitle>
                <BottomSheetHandleArea />
                <BottomSheetTitleContainer>
                  <BottomSheetTitleBox>플랫폼 선택</BottomSheetTitleBox>
                  <IconButton size="size28x28" onClick={() => onOpenChange(false)}>
                    <IcDelete />
                  </IconButton>
                </BottomSheetTitleContainer>
              </BottomSheetTitle>

              <div className="flex flex-col px-4 bg-white max-h-[532px] overflow-y-auto safe-area-bottom">
                {PLATFORMS.map((platform) => (
                  <Typography
                    key={platform.id}
                    className={`py-[11px] cursor-pointer ${
                      value?.id === platform.id ? 'text-black' : 'text-gray-600'
                    }`}
                    colorScheme={value?.id === platform.id ? 'black' : 'gray-600'}
                    variant="body13pxReg"
                    onClick={() => onPlatformSelect(platform)}
                  >
                    {platform.name}
                  </Typography>
                ))}
              </div>
            </SheetMotion>
          </SheetContent>
          <SheetDimMotion>
            <Dim />
          </SheetDimMotion>
        </SheetPortal>
      </Sheet>
    </div>
  );
};
